var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticStyle:{"min-height":"800px"}},[_c('Header'),_c('v-container',{staticClass:"ma-0 pa-0",staticStyle:{"min-height":"800px"},attrs:{"fluid":""}},[_vm._t("default")],2),(!_vm.loader)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }